/**
 * Black Friday Week — cart rules that must hold on every page, because the
 * Rebuy drawer is site-wide and a shopper can change the cart anywhere.
 *
 *   credit_tiers   apply the best code for the subtotal (BF-DAY1-50 / -100 /
 *                  -250), swapping as the cart crosses a tier up or down.
 *                  Shopify keeps one code per cart, and the codes combine with
 *                  nothing, so they never stack.
 *   mocktail_gift  the free 15 Pack (Gift: "Mocktail Gift") stays only while a
 *                  paid 24 Pack of a qualifying mocktail is in the cart, only
 *                  on that day, and only one of it.
 *   relabel        the drawer prints codes and admin titles ("BF-DAY1-100",
 *                  "BF Day 3 40"); say what they are instead.
 *
 * Which deal is today comes from the Eastern clock, not the store's. The QA
 * preview on /pages/blackfriday (?bf_preview=...) stores its simulated time
 * in sessionStorage so these rules follow it in the same tab.
 *
 * Config: window.THHBFCartConfig, from snippets/bf-cart-config.liquid.
 * Gift lines go through window.THHPickACard.reconcileGifts; "Mocktail Gift"
 * must be listed in GIFT_SOURCES there and in pick-a-card-cart-shim.liquid.
 *
 * Public API: window.THHBF (clock, readCart, addToCart, openCart, onCart).
 */
(function () {
  if (window.THHBF) return;

  var config = window.THHBFCartConfig || { deals: [] };
  var GIFT_SOURCE = config.giftSource || 'Mocktail Gift';
  var PREVIEW_KEY = 'thh_bf_preview_v1';
  var TZ = 'America/New_York';
  var LABEL_PREFIX = 'Black Friday: ';

  var cart = null;
  var busy = false;
  var codeAttempts = {};
  var giftSignature = '';
  var listeners = [];

  function log(message, error) {
    if (window.console && console.warn) console.warn('[bf-cart] ' + message, error || '');
  }

  function layer() { return window.THHPickACard || null; }

  // ---- clock ----

  function readPreview() {
    try {
      var raw = sessionStorage.getItem(PREVIEW_KEY);
      var p = raw ? JSON.parse(raw) : null;
      return p && p.nowEt && p.at ? p : null;
    } catch (e) { return null; }
  }

  /**
   * Epoch ms for an Eastern wall-clock time on a campaign day. Every campaign
   * day (24 Nov to 1 Dec) is EST, UTC-5: DST ended on 1 Nov.
   */
  function at(dateKey, hm) {
    return Date.parse(dateKey + 'T' + (hm || '00:00') + ':00-05:00');
  }

  function now() {
    var p = readPreview();
    if (!p) return Date.now();
    return at(p.nowEt.slice(0, 10), p.nowEt.slice(11, 16)) + (Date.now() - p.at);
  }

  var formatter = null;
  function etParts(ms) {
    try {
      formatter = formatter || new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      var out = {};
      formatter.formatToParts(new Date(ms)).forEach(function (part) { out[part.type] = part.value; });
      return {
        date: out.year + '-' + out.month + '-' + out.day,
        hm: out.hour + ':' + out.minute
      };
    } catch (e) {
      // No Intl time zones: assume EST, which is right for the whole week.
      var d = new Date(ms - 5 * 3600 * 1000).toISOString();
      return { date: d.slice(0, 10), hm: d.slice(11, 16) };
    }
  }

  function todayDeal() {
    var key = etParts(now()).date;
    var deals = config.deals || [];
    for (var i = 0; i < deals.length; i++) if (deals[i].date === key) return deals[i];
    return null;
  }

  // ---- cart ----

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      cart: (r.cart_url || '/cart') + '.js',
      add: (r.cart_add_url || '/cart/add') + '.js',
      change: (r.cart_change_url || '/cart/change') + '.js'
    };
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; }, function () { return { ok: r.ok, data: null }; });
    }).catch(function () { return { ok: false, data: null }; });
  }

  function readCart() {
    var l = layer();
    if (l) return l.readCart();
    return fetch(routes().cart, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // Same signal the shared layer sends after its own writes, plus a direct
  // refresh of whichever drawer is live (assets/thh-cart-drawer.js).
  function announce() {
    if (window.THHCart) { window.THHCart.refresh(); return Promise.resolve(); }
    document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') return Promise.resolve(window.Rebuy.Cart.fetchCart());
    } catch (e) {}
    return Promise.resolve();
  }

  // Refresh and open whichever drawer is live: THHCart picks Rebuy's while
  // Smart Cart is on, the theme's own drawer otherwise.
  function openCart() {
    if (window.THHCart) { window.THHCart.refresh(); window.THHCart.open(); return; }
    announce().then(function () {
      try {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') window.Rebuy.SmartCart.show();
      } catch (e) {}
    });
    document.dispatchEvent(new CustomEvent('theme:open:cart-drawer', { bubbles: true }));
  }

  function addToCart(items) {
    return post(routes().add, { items: items });
  }

  function isGift(line) {
    return !!(line.properties && line.properties.Gift === GIFT_SOURCE);
  }

  function isAnyGift(line) {
    return !!(line.properties && (line.properties.Gift || line.properties._auto_gift));
  }

  function appliedCodes(c) {
    var titles = [];
    (c.cart_level_discount_applications || []).forEach(function (a) { if (a.title) titles.push(a.title); });
    (c.discount_codes || []).forEach(function (d) { if (d.code && d.applicable !== false) titles.push(d.code); });
    return titles.map(function (t) { return String(t).toUpperCase(); });
  }

  // ---- credit tiers ----

  function bestTierIndex(tiers, subtotal) {
    var best = -1;
    (tiers || []).forEach(function (t, i) { if (subtotal >= Number(t.spend)) best = i; });
    return best;
  }

  function applyCode(code) {
    // /discount/CODE 302-redirects; /cart.js is a cheap destination.
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok; })
      .catch(function () { return false; });
  }

  function syncCreditCode(deal, c) {
    var codes = deal.codes || [];
    if (!codes.length || !deal.tiers) return null;
    var index = bestTierIndex(deal.tiers, c.items_subtotal_price);
    if (index < 0) return null;
    var wanted = codes[index];
    if (!wanted || appliedCodes(c).indexOf(String(wanted).toUpperCase()) !== -1) return null;
    // Twice per code per page at most: a code Shopify refuses (not yet
    // scheduled, say) must not turn into a request loop.
    codeAttempts[wanted] = (codeAttempts[wanted] || 0) + 1;
    if (codeAttempts[wanted] > 2) return null;
    return function () { return applyCode(wanted); };
  }

  // ---- mocktail gift ----

  function syncMocktailGift(deal, c) {
    var items = c.items || [];
    var gifts = items.filter(isGift);
    if (!gifts.length) { giftSignature = ''; return null; }

    var qualifying = deal && deal.type === 'mocktail_gift' ? (deal.qualifying || []).map(String) : [];
    var hasPaid24 = items.some(function (line) {
      return qualifying.indexOf(String(line.product_id)) !== -1 &&
        /24\s*Pack/i.test(line.variant_title || line.title || '') &&
        !isAnyGift(line) &&
        line.original_line_price > 0;
    });

    var signature = [deal ? deal.date : '', hasPaid24, gifts.map(function (g) { return g.key + 'x' + g.quantity; }).join(',')].join('|');
    if (signature === giftSignature) return null;
    giftSignature = signature;

    var l = layer();
    if (!hasPaid24) {
      return l ? function () { return l.reconcileGifts(GIFT_SOURCE, []); } : null;
    }
    // One free pack per order: keep the first line, one unit.
    var keep = gifts[0];
    if (gifts.length > 1 && l) {
      return function () { return l.reconcileGifts(GIFT_SOURCE, [keep.variant_id]); };
    }
    if (keep.quantity > 1) {
      return function () { return post(routes().change, { id: keep.key, quantity: 1 }); };
    }
    return null;
  }

  // ---- relabel ----

  function labelFor(text) {
    var t = String(text || '').trim();
    if (!t) return '';
    var upper = t.toUpperCase();
    var deals = config.deals || [];
    for (var i = 0; i < deals.length; i++) {
      var d = deals[i];
      var codes = (d.codes || []).map(function (x) { return String(x).toUpperCase(); });
      if (codes.indexOf(upper) !== -1) return LABEL_PREFIX + d.title;
      if (d.discountTitle && t.indexOf(d.discountTitle) === 0) return LABEL_PREFIX + d.title;
    }
    return '';
  }

  // Leaf elements only, and idempotent: checks the text before writing.
  function relabel() {
    if (!document.querySelector('.rebuy-cart__flyout, .thh-cart')) return;
    var nodes = document.querySelectorAll('.rebuy-cart__flyout :is(span, div, p, li, dt, dd), .thh-cart :is(span, div, p, li, dt, dd)');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;
      var label = labelFor(el.textContent);
      if (label && el.textContent.trim() !== label) el.textContent = label;
    }
  }

  // Mark free-pack rows still waiting on the discount, so the shim's FREE
  // badge is hidden rather than promising $0.00 the checkout would not show.
  // Same idea as decorateRows in assets/b2g1-cart.js.
  function decorateRows() {
    if (!cart) return;
    var gifts = (cart.items || []).filter(isGift);
    var rows = document.querySelectorAll('.rebuy-cart__flyout .rebuy-cart__flyout-item[data-pac-gift="' + GIFT_SOURCE + '"], .thh-cart .thh-line[data-gift-source="' + GIFT_SOURCE + '"]');
    for (var i = 0; i < rows.length; i++) {
      var handle = rows[i].getAttribute('data-product-handle') || '';
      if (!handle) {
        String(rows[i].className || '').split(/\s+/).forEach(function (c) {
          if (c.indexOf('product-') === 0) handle = c.slice('product-'.length);
        });
      }
      var matching = gifts.filter(function (g) { return g.handle === handle; });
      var state = matching.length && matching.every(function (g) { return g.final_line_price === 0; }) ? 'free' : 'pending';
      if (rows[i].getAttribute('data-bf-gift') !== state) rows[i].setAttribute('data-bf-gift', state);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; relabel(); decorateRows(); });
  }

  // ---- wiring ----

  function onCart(next) {
    if (!next) return;
    cart = next;
    listeners.forEach(function (fn) { try { fn(cart); } catch (e) { log('listener failed', e); } });
    schedule();
    if (busy) return;

    var deal = todayDeal();
    var work = syncMocktailGift(deal, cart);
    if (!work && deal && deal.type === 'credit_tiers') work = syncCreditCode(deal, cart);
    if (!work) return;

    busy = true;
    Promise.resolve()
      .then(work)
      .catch(function (e) { log('could not update the cart', e); })
      .then(function () {
        busy = false;
        return announce();
      })
      .then(readCart)
      .then(onCart);
  }

  function start() {
    var l = layer();
    if (l) l.onCartChange(onCart);
    readCart().then(onCart);
    var target = document.body || document.documentElement;
    new MutationObserver(schedule).observe(target, { subtree: true, childList: true, characterData: true });
  }

  window.THHBF = {
    version: 1,
    GIFT_SOURCE: GIFT_SOURCE,
    clock: { now: now, at: at, et: etParts, PREVIEW_KEY: PREVIEW_KEY },
    todayDeal: todayDeal,
    readCart: readCart,
    addToCart: addToCart,
    openCart: openCart,
    /** Refresh cart-derived UI (and re-run the rules) after a write. */
    refresh: function () { return readCart().then(onCart); },
    /** Called with every cart read, including the first. */
    onCart: function (fn) { listeners.push(fn); if (cart) fn(cart); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
